<div class="premium-searchbar">
    <app-smash-input type="text" placeholder="{{ 'PREMIUM_PROMOTION_PLACEHOLDER_SEARCH' | translate }}" [(ngModel)]="searchPromotion"
        name="searchValue2">
    </app-smash-input>
</div>


<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1>
                {{ 'PREMIUM_PROMOTION_LIST' | translate }}
            </h1>
            <h2>
                {{ 'PREMIUM_PROMOTION_LIST_DESCRIPTION' | translate }}
            </h2>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)='refresh()'>
                <i class="icon-smash_remote"></i>
            </div>
            <button class="btn-new red" (click)='createPromotion()'>{{ 'PREMIUM_PROMOTION_CREATE' | translate}}</button>
        </div>
    </div>
    <ng-container *ngIf="(promotionsLoading$ | async); else promotionsLoaded">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #promotionsLoaded>
        <ng-container *ngIf="promotions.length; else nopromotions">
            <div class="premium-card-center">
                <app-smash-data-table [data]="promotions" [searchValue]="searchPromotion"
                    [columns]='columnsEnabled' [enableColumnOptions]='false' [enableMoreOptions]='true'
                    rowClickable='true' (rowClicked)="updatePromotion($event.id)" [paginationEnabled]="true">
                    <ng-template #optionsList let-item>
                        <li (click)="updatePromotion(item.id)">
                            {{ 'PREMIUM_PROMOTION_EDIT' | translate }}
                        </li>
                        <li *ngIf="item.status === 'Enabled'" (click)="openModalConfirm(item, 'disable')">
                            {{ 'PREMIUM_PROMOTION_DISABLE' | translate }}
                        </li>
                        <li *ngIf="item.status === 'Disabled'" (click)="openModalConfirm(item, 'enable')">
                            {{ 'PREMIUM_PROMOTION_ENABLE' | translate }}
                        </li>
                        <!-- <li (click)="openModalConfirm(item, 'enable')">
                            {{ 'PREMIUM_PROMOTION_DELETE' | translate }}
                        </li> -->
                    </ng-template>
                </app-smash-data-table>
            </div>
        </ng-container>
        <ng-template #nopromotions>
            <div class="premium-card-center-no-content">
                <span class="premium-card-center-no-content-message">
                    {{ 'PREMIUM_PROMOTION_LIST_EMPTY' | translate }}
                </span>
                <!-- <button class="btn-new" (click)='createPromotion()'>{{ 'PREMIUM_PROMOTION_CREATE' | translate}}</button> -->
            </div>
        </ng-template>
    </ng-template>
</div>
